module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-italic-web.ttf?fa0b986377511d14ddd2032f4798b115";